import React from 'react'
import WorkFlow from '../../components/WorkFlow'
import Layout from '../Layout'
import Grid from '@mui/material/Unstable_Grid2';
import { useNavigate } from 'react-router-dom';
import { Typography, Button } from '@mui/material';
import './style.scss'
import { useDispatch } from 'react-redux';
import { RESET_BOOKING } from '../../Redux/constants/bookingConstants';
import Lottie from "lottie-react";
import Checked from "../../assets/images/checked.json";
import Add from '@mui/icons-material/Add';

const EnquiryDone = ({ head }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const newBooking = () => {
        dispatch({
            type: RESET_BOOKING
        });
        localStorage.removeItem("booking");
        navigate('/');
    };

    return (
        <Layout head={head}>
            <WorkFlow activeStep={3} mode={'ok'} />
            <Grid flexDirection={{ xs: 'column', md: 'row' }} style={{ display: 'flex', justifyContent: 'center', paddingTop: '4%', paddingBottom: '2%' }} marginBottom={2} >
                <Button variant="filled" style={{ borderRadius: 4, padding: '15px 30px', backgroundColor: '#f4f6f8' }} >
                    <Lottie animationData={Checked} style={{ height: 60, width: 60 }} loop={true} />
                    <span className='successText' style={{ fontSize: '18px', fontWeight: 'bold', color: 'white', marginLeft: '10px' }}>
                        Thank you for submitting enquiry. Our team will contact you for further details
                    </span>
                </Button>
            </Grid>

            <Grid style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', overflow: 'hidden', paddingBottom: '4%' }}>
                <Button type="button" variant="filled" onClick={newBooking} endIcon={<Add style={{ color: 'white' }} />} style={{ backgroundColor: '#333333', borderRadius: 4, padding: '10px 20px', height: 40 }} >
                    <Typography className='buttonText' style={{ color: '#fff', fontWeight: 'bold' }}>BACK TO HOME</Typography>
                </Button>
            </Grid>

            {/* <Grid className="thanks_msg" style={{ padding: '30px', background: '#fcfcfc', borderRadius: 8, marginBottom: 50 }}>
                <h3 className="tnks_msg_head" style={{ color: '#333', textAlign: 'center', marginBottom: 20 }}>Thank You for Your Enquiry</h3>
                <Typography style={{ textAlign: 'center', maxWidth: 800, margin: '0 auto', fontSize: 16 }}>
                    We have received your trip details including additional stops. Our operations team is currently reviewing your itinerary to calculate the custom rates and assign the best suitable vehicle. We will get back to you shortly via email or phone.
                </Typography>
            </Grid> */}
        </Layout>
    );
};

export default EnquiryDone;
